import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { DialogContent, DialogTitle, Modal } from 'base-ui'

import { DrawerTransition } from '../../../../../drawer-transition/'

import { ProductOfferList } from './ProductOfferList'

import styles from './ProductOfferDrawer.module.css'

type ProductOfferDrawerProps = {
  handleClose: () => void
  isOpen: boolean
}

export const ProductOfferDrawer: FC<ProductOfferDrawerProps> = ({
  handleClose,
  isOpen,
}) => (
  <Modal
    className={clsx(
      styles['product-offer-drawer'],
      'flex flex-col items-end justify-end rounded-l-2xl',
    )}
    closeAfterTransition
    data-qa-id="offerSelectionModal"
    onClose={handleClose}
    open={isOpen}
  >
    <DrawerTransition
      className="mt-[120px] flex h-dvh w-full flex-col overflow-y-auto rounded-t-2xl bg-light-primary-medium outline-none tablet:mt-0 tablet:max-w-screen-tablet tablet:rounded-l-2xl tablet:rounded-tr-none"
      in={isOpen}
    >
      <DialogTitle className="bg-light-primary-medium" onClose={handleClose}>
        <FormattedMessage id="productOffer.modal.title" />
      </DialogTitle>
      <DialogContent>
        <ProductOfferList />
      </DialogContent>
    </DrawerTransition>
  </Modal>
)
